import { Injectable} from '@angular/core';



@Injectable()
export abstract class SystemConfig {
	abstract pnl: {
		enableDiscountRate : boolean;
		enableNpv: boolean;
		enableIrr: boolean;
		enableSpreadsheetOpex: boolean;
		enableEbitda: boolean;
	};
}

@Injectable()
export class ClasOhlsson implements SystemConfig {
	pnl = {
		enableDiscountRate : false,
		enableNpv: false,
		enableIrr: false,
		enableSpreadsheetOpex: false,
		enableEbitda: false
	}
}

@Injectable()
export class Standard implements SystemConfig {

	pnl = {
		enableDiscountRate: true,
		enableNpv: true,
		enableIrr: true,
		enableSpreadsheetOpex: true,
		enableEbitda: true

	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/environment/system-config.ts